if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.cart?.tagName?.toLowerCase() === 'cart-drawer') this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const scopeRoot = this.closest('quick-add-modal, section, body') || document;

      /* Get selling plan and discount info */
      let selling_plan_id = null;
      if (this.form.querySelector('[name="selling_plan"]')) {
        selling_plan_id = this.form.querySelector('[name="selling_plan"]').value;
      } else {
        const linkedSellingPlan = scopeRoot.querySelector(`[name="selling_plan"][form="${ this.form.getAttribute('id') }"]`);
        if (linkedSellingPlan) {
          selling_plan_id = linkedSellingPlan.value;
        }
      }

      let discount = null;
      let discountVal = 0;
      if (this.form.querySelector('[name="properties[Discount]"]')) {
        discount = this.form.querySelector('[name="properties[Discount]"]').value;
      } else {
        const linkedDiscount = scopeRoot.querySelector(`[name="properties[Discount]"][form="${ this.form.getAttribute('id') }"]`);
        if (linkedDiscount) {
          discount = linkedDiscount.value;
        }
      }
      if (discount) {
        discountVal = Number(discount.replace(/[^0-9\.]+/g,""));
      }

      /* Check for upsell box and hijack if bundle exists */
      const formSection = this.closest('section');
      const upsellBox = formSection?.querySelector('td-upsell-box');
      const bundleResult = upsellBox?.buildCartPayload(true);
      const bundleItems = Array.isArray(bundleResult) ? bundleResult : [];

      /* null = bundle tier selected but incomplete; block submission */
      // ------------TD CHANGE-----------
      if (bundleResult === null) {
        const incompleteOrderMessage =
          upsellBox?.getIncompleteBundleButtonText?.() ||
          upsellBox?.dataset?.incompleteOrderMessage ||
          'PICK YOUR SHADES';
        this.handleErrorMessage(incompleteOrderMessage);
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        return;
      }
      // ----------END TD CHANGE---------
      
      let config, bodyData;
      
      if (bundleItems.length > 0) {
        /* Bundle exists: use JSON payload with all items */
        /* buildCartPayload() already includes main product + bundle items */
        const items = [...bundleItems];
        
        /* Apply selling plan to paid items only (free gifts typically don't belong to subscription) */
        if (selling_plan_id) {
          items.forEach((item) => {
            if (item.properties?._freeGift !== 'true') {
              item.selling_plan = selling_plan_id;
            }
          });
        }
        
        /* Apply discount properties to paid items only (skip free gifts) */
        if (discountVal > 0 && discount) {
          items.forEach((item) => {
            if (item.properties?._freeGift === 'true') return;
            if (!item.properties) item.properties = {};
            item.properties.Discount = discount;
          });
        }
        
        bodyData = { items: items };
        if (this.cart) {
          bodyData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          bodyData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        
        config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bodyData)
        };
      } else {
        /* Normal single product flow (qty = 1, buildCartPayload returns []) */
        config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      }
      
      fetch(bundleItems.length > 0 ? `${routes.cart_add_url}.js` : routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          
          /* Only call submitExtraItems for non-bundle submissions */
          if (bundleItems.length === 0) {
            if (discountVal > 0) {
              this.submitExtraItems({'id': selling_plan_id, 'discount': discount});
            } else {
              this.submitExtraItems({'id': selling_plan_id});
            }
          }
          
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    submitExtraItems(selling_plan_data = null) {
      const el = this;
      let extraItems = this.extraItems();
      if (selling_plan_data) {
        extraItems.forEach((item) => {
          item['selling_plan'] = selling_plan_data['id'];
          if (item['properties']) {
            item['properties']['Discount'] = selling_plan_data['discount'];
          } else {
            item['properties'] = {'Discount': selling_plan_data['discount']};
          }
        })
      }
      if(extraItems.length > 0) {
        let formData = {"items": extraItems};
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body:  JSON.stringify(formData)})
        .then(response => response.json())
        .then(response => {
          if (response.status) return;
          if (el.cart?.renderContents) {
            el.cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
          }
        });
      }
    }

    extraItems() {
      let extraItems = [];
      let extraVariantsId = [];
      const scopeRoot = this.closest('quick-add-modal, section, body') || document;
      let extraItemsContainer = scopeRoot.querySelector('[data-quantity-option]:checked');
      const extraSubItemsContainer = scopeRoot.querySelector('[data-sub-quantity-option]:checked');
      if (extraSubItemsContainer) {
        if (extraSubItemsContainer.classList.contains("td-active")) {
          extraItemsContainer = extraSubItemsContainer;
        }
      }
      if (extraItemsContainer) {
        let extraVariants;
        if (extraItemsContainer.hasAttribute("data-skio-quantity")) {
          extraVariants = scopeRoot.querySelectorAll("[data-skio-quantity-option-variant]:checked");
          extraVariants.forEach((v, index) => {
            let loopIndex = index + 1;
            if(loopIndex < extraItemsContainer.value){ extraVariantsId.push(v.value) }
          });
        } else {
          extraVariants = scopeRoot.querySelectorAll(`[data-quantity-option-variant="${extraItemsContainer.id}"]:checked`);
          extraVariants.forEach((v) => extraVariantsId.push(v.value));
        }
        if(extraVariantsId.length > 0) {
          let vAdded = [];
          extraItems = extraVariantsId.reduce(function(result, v) {
            if (!vAdded.includes(v)){
              let qty = 0;
              extraVariantsId.forEach((item) => {
                if(item == v){ qty = qty + 1; }
              });
              vAdded.push(v);
              result.push({ "id": parseInt(v), "quantity": qty });
            }
            return result;
          }, []);
        }
      }
      return extraItems;
    }
    
  });
}
